import { Injectable, } from '@angular/core';
import { tap } from 'rxjs';
import { BaseService } from './base.service';


@Injectable({
    providedIn: 'root'
})
export class SettingsService extends BaseService {

    private _settings = {};    
    private _lookups = {};
    public static _dateFormats: any = {};
    constructor() {
        super()
    }

    loadSettings() {
        return this.http.get(`${this.absoluteHostNameURL}AppData/settings.json`).pipe(tap((res: any) => {
            this._settings = res;
            return res;
        }))
    }

    loadLookups() {
        const lookupUrl = `/AppData/Lookups.json?v=${this.settings?.lookupVersion}`;
        return this.http.get<any>(lookupUrl).pipe(
            tap((res) => {
                this._lookups = res;
                return res;
            })
        );
    }

    public get lookups(): any {
        return this._lookups;
    }

    public get settings(): any {
        return this._settings;
    }

    public get dateFormats(): any {
        return  SettingsService._dateFormats;
    }

}
